export default {
  root: ({ instance }) => ({
    class: [
      // Position and Overflow
      'overflow-hidden',
      'relative',

      // Shape and Size
      'border-0',
      'h-5',
      { 'rounded-t-full': instance.$attrs['top-rounded'] },
      { 'rounded-b-full': instance.$attrs['bottom-rounded'] },
      { 'rounded-full': !instance.$attrs['bottom-rounded'] && !instance.$attrs['top-rounded'] },

      // Colors
      { 'bg-semantic-warning-orange-50': instance.$attrs['orange'] },
      { 'bg-semantic-success-green-50': instance.$attrs['green'] },
      { 'bg-gray-100': instance.$attrs['gray'] },
    ],
  }),
  value: ({ props, instance }) => ({
    class: [
      // Flexbox & Overflow & Position
      {
        'absolute flex flex-col items-center justify-center overflow-hidden':
          props.mode !== 'indeterminate',
      },

      // Colors
      { 'bg-semantic-warning-orange-200': instance.$attrs['orange'] },
      { 'bg-semantic-success-green-300': instance.$attrs['green'] },
      { 'bg-brand-red-primary-300': instance.$attrs['red'] },

      // Spacing & Sizing
      'm-0',
      { 'h-full w-0': props.mode !== 'indeterminate' },

      // Shape
      'border-0',

      // Transitions
      {
        'transition-width duration-1000 ease-in-out': props.mode !== 'indeterminate',
        'progressbar-value-animate': props.mode == 'indeterminate',
      },

      // Before & After (indeterminate)
      {
        'before:absolute before:top-0 before:left-0 before:bottom-0 before:bg-inherit ':
          props.mode == 'indeterminate',
        'after:absolute after:top-0 after:left-0 after:bottom-0 after:bg-inherit after:delay-1000':
          props.mode == 'indeterminate',
      },
    ],
  }),
  label: {
    class: [
      // Flexbox
      'inline-flex',

      // Font and Text
      'text-white',
      'leading-6',
    ],
  },
};
